const LISTE_NATURE_RODUIT = {
  title: 'Liste des natures de produit',
  actions: {
    search: 'Rechercher',
  },
  tab: {
    libelle: 'Nature de produit',
  },
};

export default LISTE_NATURE_RODUIT;
